import { UIDStoreController } from '../../../store/UIDStoreController.ts';
import { showDiscordShareActivityLinkPopup } from '../../../ui_popup/showRewardsProgramDialog.ts';
import { ShareActivityLinkAnalytics } from '../../../../../../shared/entity_datas/EntityDatas.ts';
export class UIDStoreSceneController {
    hide() {
        this.storeSceneContainerDiv.classList.add('hidden');
    }
    show(hash, value) {
        this.storeSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.activateStore();
        if (!UIDStoreSceneController.shouldShowDiscordShareActivityLinkPopup(hash, value)) return;
        showDiscordShareActivityLinkPopup(ShareActivityLinkAnalytics.PushReferrersToInviteMorePlayersPopupTriggered, ShareActivityLinkAnalytics.PushReferrersToInviteMorePlayersSuccessfullyShared);
    }
    static shouldShowDiscordShareActivityLinkPopup(hash, value) {
        if (hash != 'referrals') return false;
        if ((value === null || value === void 0 ? void 0 : value.includes('showpopup')) == false) return false;
        return true;
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.storeSceneContainerDiv = document.getElementById('scene_discord_store_container');
        this.storeController = new UIDStoreController();
    }
}
